import api from "../index"

const documents = api.injectEndpoints({
  endpoints: (build) => ({
    createDocument: build.mutation({
      query: (body) => ({
        url: `/documents/create`,
        method: "POST",
        body,
      }),
    }),
    documentsList: build.query({
      query: (params) => ({
        url: `/documents/list`,
        method: "GET",
        params,
      }),
    }),
    documentDelete: build.mutation({
      query: ({ id }) => ({
        url: `/documents/${id}`,
        method: "DELETE",
      }),
    }),
    getDocument: build.query({
      query: ({ id }) => ({
        url: `/documents/${id}`,
        method: "GET",
      }),
    }),
    editDocument: build.mutation({
      query: ({ id, ...rest }) => ({
        url: `/documents/${id}`,
        method: "PUT",
        body: { ...rest },
      }),
    }),
  }),
})

export const {
  useCreateDocumentMutation,
  useDocumentDeleteMutation,
  useEditDocumentMutation,
  useLazyDocumentsListQuery,
  useLazyGetDocumentQuery,
} = documents
